import React, { useState } from 'react';
import { XMLParser } from 'fast-xml-parser';

const MantraScanner = () => {
  const [status, setStatus] = useState('Idle');
  const [fingerData, setFingerData] = useState(null);

  // Default Mantra RD Service Port range is 11100 - 11105
  const RD_SERVICE_URL = 'http://127.0.0.1:11100';

  // Step 1: Check if RD Service and Device are Ready
  const checkDeviceStatus = async () => {
    setStatus('Checking device connection...');
    try {
      const response = await fetch(`${RD_SERVICE_URL}/`, {
        method: 'RDSERVICE', // Special HTTP method used by UIDAI RD Services
      });

      const textData = await response.text();
      const parser = new XMLParser({ ignoreAttributes: false });
      const jsonObj = parser.parse(textData);

      const rdStatus = jsonObj?.RDInterface?.['@_status'];
      const rdInfo = jsonObj?.RDInterface?.['@_info'];

      if (rdStatus === 'READY') {
        setStatus(`Device Ready: ${rdInfo}`);
        return true;
      } else {
        setStatus(`Device Not Ready. Status: ${rdStatus}`);
        return false;
      }
    } catch (error) {
      console.error(error);
      setStatus('Failed to reach Mantra RD Service. Is it running?');
      return false;
    }
  };

  // Step 2: Capture Fingerprint Data
  const captureFingerprint = async () => {
    const isReady = await checkDeviceStatus();
    if (!isReady) return;

    setStatus('Place finger on the scanner...');

    // UIDAI standard PID Options XML structure required by Mantra RD Service
    const pidOptions = `
      <PidOptions ver="1.0">
        <Opts fCount="1" fType="2" iCount="0" pCount="0" format="0" pidVer="2.0" timeout="10000" env="P" />
      </PidOptions>
    `.trim();

    try {
      const response = await fetch(`${RD_SERVICE_URL}/rd/capture`, {
        method: 'CAPTURE', // UIDAI Standard Capture Request
        headers: {
          'Content-Type': 'text/xml',
        },
        body: pidOptions,
      });

      const xmlText = await response.text();
      const parser = new XMLParser({ ignoreAttributes: false });
      const jsonObj = parser.parse(xmlText);

      const pidData = jsonObj?.PidData;
      const errCode = pidData?.Resp?.['@_errCode'];
      const errInfo = pidData?.Resp?.['@_errInfo'];

      if (errCode === '0') {
        // Success
        const capturedInfo = {
          quality: pidData?.Resp?.['@_qScore'],
          deviceInfo: pidData?.DeviceInfo,
          // Encrypted PidData string used for Aadhaar / E-KYC verification
          pidDataXml: pidData?.Data?.['#text'],
        };

        setFingerData(capturedInfo);
        setStatus(`Capture Successful! Quality: ${capturedInfo.quality}%`);
      } else {
        setStatus(`Capture Failed: ${errInfo} (Error Code: ${errCode})`);
      }
    } catch (error) {
      console.error(error);
      setStatus('Error while capturing fingerprint data.');
    }
  };

  return (
    <div style={{ padding: '20px', fontFamily: 'sans-serif' }}>
      <h2>Mantra MFS110 Scanner</h2>
      <p><strong>Status:</strong> {status}</p>

      <button onClick={captureFingerprint} style={{ padding: '10px 20px', cursor: 'pointer' }}>
        Scan Fingerprint
      </button>

      {fingerData && (
        <div style={{ marginTop: '20px', background: '#f4f4f4', padding: '10px' }}>
          <h3>Capture Details</h3>
          <p><strong>Quality Score:</strong> {fingerData.quality}%</p>
          <p><strong>Encrypted Biometric Data (Truncated):</strong></p>
          <textarea
            rows="5"
            cols="50"
            value={fingerData.pidDataXml || ''}
            readOnly
          />
        </div>
      )}
    </div>
  );
};

export default MantraScanner;